// extracted by css-extract-rspack-plugin
export default {"wrapper":"bXsMJxsGug8qUQgE"};